module.exports = __webpack_public_path__ + "static/media/form.edacb030.svg";